export const COMPANY_NAME = 'K-8.ai';
